import { BillType } from 'realhaus-sdk';
import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../global/storeContext';
import { IBillPayResponse } from '../../utils/apiClient';
import { Dialog, DialogContent, Divider, Grid, Typography } from '@material-ui/core';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { StripePublishableKey } from '../../appConfig';

export const StripePaymentForm: React.FC<{
    openStripeModal: boolean;
    onClose: (paymentSuccessful: boolean, checkoutSessionId?: string) => void;
    billType: BillType | undefined;
    feeBreakdown?: { fee: number; netAmount: number };
    initPaymentCallback: (stripeData?: {}) => Promise<IBillPayResponse | undefined> | undefined;
}> = observer(({ openStripeModal, onClose, billType, initPaymentCallback, feeBreakdown }) => {
    const { uiStore, analyticsStore } = React.useContext(RootStoreContext);

    const stripePromise = loadStripe(StripePublishableKey ?? '');
    const checkoutSessionIdRef = useRef<string | undefined>();

    const closeDialog = () => {
        onClose(false, checkoutSessionIdRef.current);
    };

    const fetchClientSecret = async () => {
        // Fetch the AccountSession client secret
        const acctSession = await initPaymentCallback({});

        if (!acctSession) {
            // Handle errors on the client side here
            const error = 'Failed to create Stripe Account Session.';
            console.error('An error occurred: Failed to create Stripe Account Session.', error);
            return '';
        } else {
            checkoutSessionIdRef.current = acctSession?.stripe?.checkoutSessionId;
            return acctSession?.stripe?.checkoutSessionClientSecret ?? '';
        }
    };

    return (
        <>
            <Dialog open={openStripeModal} onClose={closeDialog} maxWidth='sm' fullWidth>
                <DialogContent>
                    <Grid
                        container
                        style={{
                            marginTop: '15px',
                            marginBottom: '15px',
                            padding: '15px',
                        }}
                        spacing={3}
                    >
                        <Grid item xs={12}>
                            <Typography variant='h5'>Provide Card Details</Typography>
                            <Divider
                                variant='fullWidth'
                                style={{ marginTop: '8px', width: '100%' }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <EmbeddedCheckoutProvider
                                stripe={stripePromise}
                                options={{
                                    onComplete: () => {
                                        console.log('Checkout Complete');
                                        onClose(true);
                                    },
                                    fetchClientSecret,
                                }}
                            >
                                <EmbeddedCheckout />
                            </EmbeddedCheckoutProvider>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
});
